module.exports = __webpack_public_path__ + "img/title.0236170b.png";